import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) setVisible(true);
  }, []);

  const decide = (choice) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ choice, at: new Date().toISOString() }),
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Consenso cookie"
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[9998] bg-white border border-line rounded-lg shadow-2xl p-5"
    >
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded bg-brand/10 text-brand flex items-center justify-center shrink-0">
          <Cookie className="w-5 h-5" />
        </div>
        <div className="flex-1">
          <div className="font-display text-base text-ink">Cookie e privacy</div>
          <p className="mt-1 text-sm text-ink-muted leading-relaxed">
            Utilizziamo solo cookie tecnici strettamente necessari al funzionamento del sito.
            Nessuna profilazione, nessun tracciamento pubblicitario.{" "}
            <Link to="/privacy" className="text-brand hover:underline whitespace-nowrap">Leggi l'informativa</Link>.
          </p>
        </div>
        <button
          onClick={() => decide("decline")}
          aria-label="Chiudi banner cookie"
          className="text-ink-muted hover:text-ink shrink-0"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
      <div className="mt-4 flex gap-2">
        <button
          onClick={() => decide("decline")}
          data-testid="cookie-decline"
          className="flex-1 h-10 border border-line rounded text-sm hover:bg-line/40"
        >
          Rifiuta non essenziali
        </button>
        <button
          onClick={() => decide("accept")}
          data-testid="cookie-accept"
          className="flex-1 h-10 bg-brand text-white rounded text-sm font-display uppercase tracking-widest hover:bg-brand-dark"
        >
          Accetta
        </button>
      </div>
    </div>
  );
}
